import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Button } from 'antd';
import { faUser, faMessageLines  } from '@fortawesome/pro-regular-svg-icons'
import FAIcon from 'components/util-components/FAIcon';

export const PlusAction = () => {

  const history = useHistory();
  let lang = [
    {
      'key': 'contact',
      'name': 'Contact',
      'path': '/clients/add',
      'icon': faUser,
    },
    {
      'key': 'request',
      'name': 'Notification',
      'path': '/requests/add',
      'icon': faMessageLines,
    }, 
  ]


  const onActionSelect = (path) => {
    history.push(path); 
  }

  const languageOption = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <h4 className="mb-0">Create New...</h4>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {
            lang.map((elm, i) => {
              return (
                <Menu.Item
                  key={i}
                  onClick={() => onActionSelect(elm.path)}
                >
                  <span className="d-flex justify-content-between align-items-center">
                    <div>
                      <FAIcon icon={elm.icon} className='app-fa-menu-item-icon' />
                      <span className="font-weight-normal ml-2">{elm.name}</span>
                    </div>
                  </span>
                </Menu.Item>
              )
            })
          }
        </Menu>
      </div>
    </div>
  )
  return (
    <Dropdown placement="bottomRight" overlay={languageOption} trigger={['click']}>
      <Menu mode="horizontal">
        <Menu.Item key="language" className="app-header-top-nav-menu-item">
          <a href="#/" onClick={e => e.preventDefault()}>
            <Button className="nav-icon mr-0" type="primary" shape="circle" icon={<PlusOutlined />} />
          </a>
        </Menu.Item>
      </Menu>
    </Dropdown>
  )
}

export default PlusAction 